import { FC, useEffect } from "react";
import { Wrapper } from "./style";
import { ELEMENT_COLORS } from "./const";
import { Colors } from "@brg/ui";
import { useDispatch } from "react-redux";
import { ThemeSlideColorActions } from "shared/reducers/ThemeSlideColorSlice";
import DafesTitle from "./DafesTitle";

//const ELEMENTS_DISTANCE = '70';
//const ELEMENTS_DISTANCE_M = '45';
const DEFAULT_COLORS =  { color: '#151514', hover: Colors.zelWhite10 }

export const InteractiveTabs: FC<{ 
    items: string[], 
    onTabChange: (tab: string) => void, 
    currentTab: string 
}> = ({
    currentTab
}) => {
    //todo убарть старый код
    const dispatch = useDispatch();
    
    const isActive = (i: string) => {
        if (i === currentTab)
            return true;
        return false;
    }

    const getActiveElementColor = (i: string) => 
        isActive(i) ? ELEMENT_COLORS?.find(
            (color) => color.name === i)?.colors : DEFAULT_COLORS;

    useEffect(() => {
        dispatch(ThemeSlideColorActions.setColor(
            getActiveElementColor(currentTab)
        ))

        return () => {
            dispatch(ThemeSlideColorActions.resetColor())
        }
    }, [currentTab, dispatch])

    return (
        <Wrapper>
            <DafesTitle currentTab={currentTab}/>
        </Wrapper>
    )
}import { FC, useEffect } from "react";
import { Wrapper } from "./style";
import { ELEMENT_COLORS } from "./const";
import { Colors } from "@brg/ui";
import { useDispatch } from "react-redux";
import { ThemeSlideColorActions } from "shared/reducers/ThemeSlideColorSlice";
import DafesTitle from "./DafesTitle";

//const ELEMENTS_DISTANCE = '70';
//const ELEMENTS_DISTANCE_M = '45';
const DEFAULT_COLORS =  { color: '#151514', hover: Colors.zelWhite10 }

export const InteractiveTabs: FC<{ 
    items: string[], 
    onTabChange: (tab: string) => void, 
    currentTab: string 
}> = ({
    currentTab
}) => {
    //todo убарть старый код
    const dispatch = useDispatch();
    
    const isActive = (i: string) => {
        if (i === currentTab)
            return true;
        return false;
    }

    const getActiveElementColor = (i: string) => 
        isActive(i) ? ELEMENT_COLORS?.find(
            (color) => color.name === i)?.colors : DEFAULT_COLORS;

    useEffect(() => {
        dispatch(ThemeSlideColorActions.setColor(
            getActiveElementColor(currentTab)
        ))

        return () => {
            dispatch(ThemeSlideColorActions.resetColor())
        }
    }, [currentTab, dispatch])

    return (
        <Wrapper>
            <DafesTitle currentTab={currentTab}/>
        </Wrapper>
    )
}